import Money from 'common/Money';
import * as React from 'react';
import {Link} from 'react-router-dom';
import {AccountInlineDisplay} from 'src/AccountInlineDisplay';
import {AmountDisplay} from 'src/AmountDisplay';
import {BenefitField} from 'src/DetailComponents/RawTransaction/BenefitField';
import InputGroup from 'src/InputGroup';
import {formatFullDate} from 'src/lib/displayDate';
import type {FullRawTransactionFragment} from '@transactions/graphql';

type Props = {
  rawTransaction: FullRawTransactionFragment;
};

// InputGroup labels carry pt-1.5 to line up with the first line of an h-9
// input; plain-text values need the same offset to sit on that line
const Value = ({children}: {children: React.ReactNode}) => (
  <div className="pt-1.5">{children}</div>
);

const Display = (props: Props) => {
  const {rawTransaction} = props;
  const amount = Money.fromServer(rawTransaction);

  return (
    <div className="flex flex-col gap-2 p-4">
      <InputGroup label="Amount">
        <Value>
          <AmountDisplay
            amount={amount}
            align="left"
            variant="plain"
          />
        </Value>
      </InputGroup>
      <InputGroup label="Description">
        <Value>{rawTransaction.description}</Value>
      </InputGroup>
      <InputGroup label="Date">
        <Value>{formatFullDate(rawTransaction.date)}</Value>
      </InputGroup>
      <InputGroup label="Account">
        <Value>
          {/* inline-flex so the link is only as wide as the badge it wraps,
              rather than a full-width hover target across the row */}
          <Link
            to={`/accounts/${rawTransaction.account._id}`}
            className="inline-flex max-w-full hover:underline"
          >
            <AccountInlineDisplay account={rawTransaction.account} />
          </Link>
        </Value>
      </InputGroup>
      <InputGroup label="Benefit">
        <BenefitField rawTransaction={rawTransaction} />
      </InputGroup>
      {rawTransaction.adjustmentForAnchorId && (
        <InputGroup label="Adjustment">
          <Value>
            {/* The anchor may have been deleted after an unreconcile — the
                stamp outlives it by design, and the link then just misses. */}
            <span className="text-muted-foreground">
              Created by reconcile fix up to close{' '}
              <Link
                to={`/balance-anchors/${rawTransaction.adjustmentForAnchorId}`}
                className="hover:underline"
              >
                this balance anchor
              </Link>
              .
            </span>
          </Value>
        </InputGroup>
      )}
    </div>
  );
};

export default Display;
